import { useCountryConfig } from 'modules/common/hooks/useCountryConfig'
import { PropsWithChildren } from 'react'
import { BetaVersionBannerMessage } from '../BetaVersionBannerMessage/BetaVersionBannerMessage'
import LayoutSimple from './LayoutSimple'

interface Props {
  withBetaVersionBanner?: boolean
  withUser?: boolean
  withExtendedSupport?: boolean
}

export const LayoutCentered = ({
  children,
  withBetaVersionBanner,
  withUser,
}: PropsWithChildren<Props>) => {
  const { isBeta } = useCountryConfig()

  return (
    <LayoutSimple withUser={withUser}>
      <div className="flex min-h-dashboardViewport w-full flex-col items-center bg-white md:bg-info-90">
        {withBetaVersionBanner && isBeta && (
          <BetaVersionBannerMessage className="self-stretch" />
        )}
        <div className="grow pb-24 pt-0 md:pt-24">
          <div className="bg-white px-6 py-4 pt-0 md:w-centered-content md:px-20 md:py-14 md:pt-8">
            {children}
          </div>
        </div>
      </div>
    </LayoutSimple>
  )
}
